<template>
	<div class="qrcode">
        <el-dialog :title="$t('other.a940')" :visible.sync="printHistorDiaCopy" @close="$emit('update:printHistorDia',false)" width="50%">
            <div style="width:100%">
               
                <div style="margin-bottom:10px">
                     {{$t('other.a941')}}：
                <el-date-picker
                    v-model="value6"
                    type="daterange"
                    size="mini"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('other.a47')"
                    :start-placeholder="$t('other.a45')"
                    :end-placeholder="$t('other.a46')"
                    @change="getStoreOperateRecordBytime"
                    :picker-options="pickerOptions2">
                </el-date-picker>
			</div>
			<div style="width: 100%;">
				<el-table border :data="printhistory" height="400px" >
			
					<el-table-column :label="$t('other.a942')">
						<template slot-scope="props">
							<span>{{conversion(props.row.printType)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a943')">
						<template slot-scope="props">
							<span>{{props.row.total.length}}</span>
						</template>
					</el-table-column>
                    <el-table-column :label="$t('other.a590')">
						<template slot-scope="props">
							<span>{{getTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" :label="$t('other.a33')">
						<template slot-scope="props">
							<span style="cursor: pointer;color:#409EFF ;" @click="printAgin(props.row.printType,props.row.total,props.row.platform)">{{$t('other.a944')}}</span>
						</template>

					</el-table-column>

				</el-table>
			</div>
            </div>
			<span slot="footer" class="dialog-footer">
				<div class="block">

					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
					 :page-sizes="[10, 20, 30, 50]" :page-size="getDatatParams.offset" layout="total, sizes, prev, pager, next, jumper" :total="printhistorycount01">
					</el-pagination>
				</div>
				<el-button type="primary" @click="printHistorDia=false">{{$t('other.a5')}} </el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>

	import {mapState,mapActions,mapMutations} from 'vuex'
    import order from '../../../../api/moudles/order';
	import utils from '../../../../utils/utils'
	import newOrdersApi from '../../../../api/moudles/newOrders'

	export default {
		name: "Dialog",
		data() {
			return {
				value:null,
                printHistorDiaCopy:false,
                getDatatParams:{
                    end:utils.getRecentDays(0),
                    start:utils.getRecentDays(-7),
                    offset:20,
                    page:0,
                    shopIds:null,
                    storeIds:null,
                    userId:this.userId
                },
                printhistory:null,
                printhistorycount01:0,
                currentPage:1,
                value6:[],
                pickerOptions2:{
                    shortcuts: [{
                    text: this.$t("other.a130"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a131"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a132"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                    }]
                },

			};
		},

		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				auditOrder_success: state => state.order.auditOrder_success,
				auditOrder_error: state => state.order.auditOrder_error,
				autoReives: state => state.order.autoReives,
				cateGoryListCopy: state => state.mygoods.cateGoryListCopy,
				mygoodslist: state => state.mygoods.mygoodslist,
				goodsTotal:state => state.mygoods.goodsTotal,

		
			}),

			cusCodeCopy(){
				let ttp =this.getDataList.cusCode
				return ttp
			}

			
			


		},
		props: {
			printHistorDia:{
				type: Boolean,
				default: false
			},
	

		},
		watch:{
			printHistorDia(){
				this.printHistorDiaCopy=this.printHistorDia
                if(this.printHistorDia){
                    this.value6[0]=utils.getRecentDays(-7)
                    this.value6[1]=utils.getRecentDays(0)
                    this.getDatatParams.end=utils.CurdateAddoneday(utils.getRecentDays(0)),
                    this.getDatatParams.start=utils.getRecentDays(-7),
                    this.getDatatParams.offset=20,
                    this.getDatatParams.page=0,
                    this.getDatatParams.shopIds=JSON.parse(localStorage.getItem('userInfo')).shopIds,
                    this.getDatatParams.storeIds=JSON.parse(localStorage.getItem('userInfo')).storeIds,
                    this.getDatatParams.userId=this.userId
                    this.getPrintRecord()
                    console.log(this.getDatatParams)
                
                }
			
			},

		
			

		},
		created() {
			
		},
		methods: {
			...mapActions('order', [
				'reviewOrderCopy',
			]),

            getStoreOperateRecordBytime(){
                console.log(this.value6)
                this.currentPage=1
                this.getDatatParams.page=0,
                this.getDatatParams.end=utils.CurdateAddoneday(this.value6[1]),
                this.getPrintRecord()
            },

            printAgin(num,list,platform){
                console.log(num,list,platform)
                if(num == 0){//打印默认拣货单
                    localStorage.setItem('picklistInfoCopy',JSON.stringify(list))
                    const {href}=this.$router.resolve({
                        name:'productPicklist',
                    
                    }) 
                    window.open(href)
                    
                }else if(num == 1){//打印默认备货单
                    localStorage.setItem('stockingInfoCopy',JSON.stringify(list))
                    let routeData2 = this.$router.resolve({
                        name: "productStockling",
                        query:{
                            flag:platform == 'SHOPEE' ? 0 : 1
                        }
                    })
                    window.open(routeData2.href, '_blank');
                }else if(num == 2){//打印默认面单
                   
                    newOrdersApi
                    .getOrderBillUrl(list)
                    .then(res => {
                    if(res.code === 200 ){
                    console.log('面单地址',res.data)

                    res.data.forEach(p => {
                        p.urlCopy=JSON.parse(p.url)
                    })

                        if(platform == 'SHOPEE'){
                            res.data[0].urlCopy.forEach(p => {
                                window.open(p)
                            })
                        }
                        if(platform == 'LAZADA'){
                        
                            let Base64 = require('js-base64').Base64
                            let file=res.data[0].urlCopy.data.document.file
                            let newfile=Base64.decode(file)
                            localStorage.removeItem('alipay')
                            localStorage.setItem('html',newfile)
                            let newUrl=location.host + '/sealpage'
                            console.log(newUrl)
                            window.open('https://' + newUrl)
                        }

                    }
                    })
                }else if(num == 3){//默认打印面单&拣货单'
                    localStorage.setItem('unprocessedOrderIds', JSON.stringify(list))
                    let routeData2 = this.$router.resolve({
                        name: "productAndPicklist",
                    })
                    window.open(routeData2.href, '_blank');
                }
            },

            getPrintRecord(){
                newOrdersApi
                .getPrintHistory(this.getDatatParams)
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                res.data.list.forEach(p => {
                    p.total=p.orderIds.split(',')
                })
                this.printhistory=res.data.list
                this.printhistorycount01=res.data.count
                }else{
                this.$message.warning(res.msg)
                }
                })
            },

            getTime(time){
                return utils.renderTime(time)
            },

            conversion(num){
                return utils.printRecord(num)
            },

            handleSizeChange(val) {
				this.getDatatParams.offset = Number(`${val}`)
                this.handleCurrentChange()
			
			},
			handleCurrentChange(val) {
				this.getDatatParams.page = Number(`${val}`) ? (Number(`${val}`) - 1)*this.getDatatParams.offset : 0
                this.currentPage= Number(`${val}`) ? Number(`${val}`) : 1
                console.log(this.getDatatParams)
                this.getPrintRecord()
            }    

        }	
	}
</script>

<style lang="scss" scoped>
.pic{
	display: inline-block;
	width: 40px;
	height: 40px;


	img{
		width: 100%;
	}
}




.el-table {
    thead {
      .el-table-column--selection {
        .cell {
          display: none;
        }
      }
   }
}

.customerPopBox{
	width: 100%;
	display: flex;
	height: 450px;
	flex-direction: column;

	.conditon{
		display: flex;
		margin:0 10px;
	}
}



</style>
